import { Directive, ViewContainerRef, ɵɵdefineInjectable, Injectable, EventEmitter, Component, Output, Input, ComponentFactoryResolver, ViewChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/router';

const _c0 = function (a0) { return { "toast-hide": a0 }; };
const _c1 = function (a0, a1, a2, a3) { return { "fa-exclamation-triangle toast-icon-event": a0, "fa-exclamation-circle toast-icon-alert": a1, "fa-info-circle toast-icon-message": a2, "fa-thumbtack toast-icon-task": a3 }; };
const _c2 = function (a0, a1, a2, a3) { return { "btn-primary": a0, "btn-danger": a1, "btn-info": a2, "btn-warning": a3 }; };
function EventNotifyWatcherComponent_ng_template_4_Template(rf, ctx) { }
class EventNotificationDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
EventNotificationDirective.ɵfac = function EventNotificationDirective_Factory(t) { return new (t || EventNotificationDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
EventNotificationDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: EventNotificationDirective, selectors: [["", "event-notification-stack", ""]] });
EventNotificationDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EventNotificationDirective, [{
        type: Directive,
        args: [{
                selector: '[event-notification-stack]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();

class SysNotifyService {
    constructor() {
        this.authorized = false;
        this.authorized = this.checkNotificationAuth();
    }
    checkNotificationAuth() {
        try {
            Notification.requestPermission().then();
        }
        catch (e) {
            return false;
        }
        return true;
    }
    showNotify(notify, onClose) {
        if (this.authorized) {
            var img = "/assets/ng-alto-event-stream-lib/img/" + notify.type + ".png";
            var options = {
                body: notify.message,
                icon: img,
                badge: img,
                image: img,
                requireInteraction: true,
                data: notify
            };
            var n = new Notification(notify.link_text, options);
            n.addEventListener('click', function (event) {
                console.log(event);
                try {
                    if (typeof onClose == 'function') {
                        onClose(notify);
                    }
                    else {
                        location.href = event.currentTarget.data.link;
                        n.close();
                    }
                }
                catch (error) {
                    console.log(error);
                }
            }, false);
            return n;
        }
        else {
            console.debug('Push notification is not enabled');
            return null;
        }
    }
}
SysNotifyService.ɵfac = function SysNotifyService_Factory(t) { return new (t || SysNotifyService)(); };
SysNotifyService.ɵprov = ɵɵdefineInjectable({ factory: function SysNotifyService_Factory() { return new SysNotifyService(); }, token: SysNotifyService, providedIn: "root" });
SysNotifyService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SysNotifyService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class EventNotifyComponent {
    constructor(sysNotifyService) {
        this.sysNotifyService = sysNotifyService;
        this.close = new EventEmitter();
        this.audio = new Audio();
        this.elapsedTime = 'Ahora Mismo';
        this.notification = null;
        this.interval = null;
        this.playAudio = false;
        this._notify = {
            type: 'event',
            message: '',
            link: '#',
            link_text: 'See Event',
            created_at: Date.now()
        };
        this.event = {
            name: '',
            notify: this.notify,
            componentViewRef: null,
            componentInstance: this
        };
        document.addEventListener("visibilitychange", function () {
            console.log(document.hidden, document.visibilityState);
        }, false);
    }
    get notify() {
        return this._notify;
    }
    ;
    set notify(value) {
        this._notify = value;
        this.playSound();
        this.notification = this.sysNotifyService.showNotify(value, (n) => {
            this.onAccept();
        });
    }
    ;
    ngOnInit() {
        this.interval = setInterval(() => this.showElapsedTime(), 1000 * 1);
    }
    ngOnDestroy() {
        clearInterval(this.interval);
    }
    showElapsedTime() {
        let now = Date.now();
        let elapsed = Math.trunc((now - this.notify.created_at) / 1000);
        if (elapsed < 5) {
            this.elapsedTime = 'Ahora Mismo';
        }
        else if (elapsed < 60) {
            this.elapsedTime = 'Hace ' + elapsed + ' seg';
        }
        else if (elapsed < 3600) {
            let min = Math.trunc(elapsed / 60);
            let sec = Math.trunc(elapsed - min * 60);
            this.elapsedTime = 'Hace ' + min + ' min ' + sec + ' seg';
        }
        else {
            let h = Math.trunc(elapsed / 3600);
            this.elapsedTime = 'Hace más de ' + h + ' horas';
        }
    }
    onClose() {
        this.audio.pause();
        this.event.name = 'close';
        if (this.notification) {
            this.notification.close();
        }
        setTimeout(() => {
            this.close.emit(this.event);
        }, 1000 * 1);
    }
    onAccept() {
        this.event.name = 'accept';
        if (this.notification) {
            this.notification.close();
        }
        location.href = this.notify.link;
    }
    playSound() {
        console.log('playing sound ' + this.notify.type + '.mp3');
        this.audio.src = "/assets/ng-alto-event-stream-lib/audio/" + this.notify.type + ".mp3";
        this.audio.load();
        this.audio.play();
        this.audio.addEventListener('ended', () => {
            this.audio.play();
        });
    }
}
EventNotifyComponent.ɵfac = function EventNotifyComponent_Factory(t) { return new (t || EventNotifyComponent)(ɵngcc0.ɵɵdirectiveInject(SysNotifyService)); };
EventNotifyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EventNotifyComponent, selectors: [["event-event-notify"]], inputs: { notify: "notify" }, outputs: { close: "close" }, decls: 15, vars: 21, consts: [["role", "alert", "aria-live", "assertive", "aria-atomic", "true", 1, "toast", 3, "ngClass"], [1, "toast-header"], [1, "fas", "fa-exclamation-circle", 3, "ngClass"], [1, "mr-auto"], [1, "text-muted"], ["type", "button", "data-dismiss", "toast", "aria-label", "Close", 1, "ml-2", "mb-1", "close", 3, "click"], ["aria-hidden", "true"], [1, "toast-body"], [3, "innerHtml"], ["type", "button", 1, "btn", "btn-primary", 3, "ngClass", "click"]], template: function EventNotifyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵelementStart(3, "strong", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵpipe(5, "uppercase");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "small", 4);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "button", 5);
        ɵngcc0.ɵɵlistener("click", function EventNotifyComponent_Template_button_click_8_listener() { return ctx.onClose(); });
        ɵngcc0.ɵɵelementStart(9, "span", 6);
        ɵngcc0.ɵɵtext(10, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵelement(12, "div", 8);
        ɵngcc0.ɵɵelementStart(13, "button", 9);
        ɵngcc0.ɵɵlistener("click", function EventNotifyComponent_Template_button_click_13_listener() { return ctx.onAccept(); });
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c0, ctx.event.name == "close" || ctx.event.name == "accept"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(11, _c1, ctx.notify.type == "event", ctx.notify.type == "alert", ctx.notify.type == "message", ctx.notify.type == "task"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 7, ctx.notify.type));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.elapsedTime);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("innerHtml", ctx.notify.message, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(16, _c2, ctx.notify.type == "event", ctx.notify.type == "alert", ctx.notify.type == "message", ctx.notify.type == "task"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.notify.link_text, " ");
    } }, directives: [ɵngcc1.NgClass], pipes: [ɵngcc1.UpperCasePipe], styles: [".toast[_ngcontent-%COMP%]{-webkit-animation:shake .82s cubic-bezier(.36,.07,.19,.97) backwards,show .5s linear backwards;animation:shake .82s cubic-bezier(.36,.07,.19,.97) backwards,show .5s linear backwards;transform:translateZ(0);opacity:1;width:340px;overflow:hidden;font-size:.875rem;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .25rem .75rem rgba(0,0,0,.4);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);border-radius:.25rem;margin-bottom:4px}.toast-hide[_ngcontent-%COMP%]{-webkit-animation:hide .5s forwards!important;animation:hide .5s forwards!important}.toast-header[_ngcontent-%COMP%]{display:flex;align-items:center;padding:.25rem .75rem;font-weight:700;color:#6c757d;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05)}.close[_ngcontent-%COMP%]{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}button.close[_ngcontent-%COMP%]{padding:0;background-color:transparent;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}.btn[_ngcontent-%COMP%]{display:inline-block;font-weight:400;text-align:center;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}.btn-danger[_ngcontent-%COMP%]{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-primary[_ngcontent-%COMP%]{color:#fff;background-color:#007bff;border-color:#007bff}.btn-info[_ngcontent-%COMP%]{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-warning[_ngcontent-%COMP%]{color:#212529;background-color:#ffc107;border-color:#ffc107;color:#585858}.toast-body[_ngcontent-%COMP%]{padding:.75rem;display:flex;flex-direction:column}.toast-icon-event[_ngcontent-%COMP%]{color:#00a2ff;margin-right:6px}.toast-icon-alert[_ngcontent-%COMP%]{color:red;margin-right:6px}.toast-icon-message[_ngcontent-%COMP%]{color:#17a2b8;margin-right:6px}.toast-icon-task[_ngcontent-%COMP%]{color:#ffc107;margin-right:6px}@-webkit-keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}@keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}@-webkit-keyframes show{10%{height:0;opacity:0}50%{height:60px;opacity:.5}to{height:120px;opacity:1}}@keyframes show{10%{height:0;opacity:0}50%{height:60px;opacity:.5}to{height:120px;opacity:1}}@-webkit-keyframes hide{10%{height:120px;opacity:1}50%{height:60px;opacity:.5}to{height:0;opacity:0}}@keyframes hide{10%{height:120px;opacity:1}50%{height:60px;opacity:.5}to{height:0;opacity:0}}"] });
EventNotifyComponent.ctorParameters = () => [
    { type: SysNotifyService }
];
EventNotifyComponent.propDecorators = {
    close: [{ type: Output }],
    notify: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EventNotifyComponent, [{
        type: Component,
        args: [{
                selector: 'event-event-notify',
                template: "<div class=\"toast \" \n  [ngClass]=\"{'toast-hide':event.name == 'close' || event.name == 'accept' }\" \n  role=\"alert\"\n  aria-live=\"assertive\" \n  aria-atomic=\"true\">\n  <div class=\"toast-header\">\n\n    <i class=\"fas fa-exclamation-circle\" \n      [ngClass]=\"{'fa-exclamation-triangle toast-icon-event': notify.type == 'event',\n      'fa-exclamation-circle toast-icon-alert': notify.type == 'alert',\n      'fa-info-circle toast-icon-message': notify.type == 'message',\n      'fa-thumbtack toast-icon-task':  notify.type == 'task'}\">\n    </i>\n\n    <strong class=\"mr-auto\">{{notify.type | uppercase}}</strong>\n    <small class=\"text-muted\">{{elapsedTime}}</small>\n\n    <button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"Close\" \n      (click)=\"onClose()\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n  </div>\n\n  <div class=\"toast-body\">\n    <div [innerHtml]=\"notify.message\"></div>\n    <button type=\"button\" class=\"btn btn-primary\" \n      (click)=\"onAccept()\" \n      [ngClass]=\"{'btn-primary': notify.type == 'event',\n      'btn-danger': notify.type == 'alert',\n      'btn-info': notify.type == 'message',\n      'btn-warning': notify.type == 'task'}\">\n      {{notify.link_text}}\n    </button>\n  </div>\n</div>",
                styles: [".toast{-webkit-animation:shake .82s cubic-bezier(.36,.07,.19,.97) backwards,show .5s linear backwards;animation:shake .82s cubic-bezier(.36,.07,.19,.97) backwards,show .5s linear backwards;transform:translateZ(0);opacity:1;width:340px;overflow:hidden;font-size:.875rem;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .25rem .75rem rgba(0,0,0,.4);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);border-radius:.25rem;margin-bottom:4px}.toast-hide{-webkit-animation:hide .5s forwards!important;animation:hide .5s forwards!important}.toast-header{display:flex;align-items:center;padding:.25rem .75rem;font-weight:700;color:#6c757d;background-color:hsla(0,0%,100%,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05)}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}button.close{padding:0;background-color:transparent;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}.btn{display:inline-block;font-weight:400;text-align:center;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}.btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}.btn-info{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-warning{color:#212529;background-color:#ffc107;border-color:#ffc107;color:#585858}.toast-body{padding:.75rem;display:flex;flex-direction:column}.toast-icon-event{color:#00a2ff;margin-right:6px}.toast-icon-alert{color:red;margin-right:6px}.toast-icon-message{color:#17a2b8;margin-right:6px}.toast-icon-task{color:#ffc107;margin-right:6px}@-webkit-keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}@keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}@-webkit-keyframes show{10%{height:0;opacity:0}50%{height:60px;opacity:.5}to{height:120px;opacity:1}}@keyframes show{10%{height:0;opacity:0}50%{height:60px;opacity:.5}to{height:120px;opacity:1}}@-webkit-keyframes hide{10%{height:120px;opacity:1}50%{height:60px;opacity:.5}to{height:0;opacity:0}}@keyframes hide{10%{height:120px;opacity:1}50%{height:60px;opacity:.5}to{height:0;opacity:0}}"]
            }]
    }], function () { return [{ type: SysNotifyService }]; }, { close: [{
            type: Output
        }], notify: [{
            type: Input
        }] }); })();

class EventNotifyWatcherComponent {
    constructor(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.token = '12345678';
        this.eventHost = 'http://localhost:8020';
        this.account_id = -1;
        this.intances = [];
    }
    ngOnInit() {
        socket_event.connect(this.eventHost + '/socket.event.movup', this.token, this.account_id);
        socket_event.addEventListener('*', (e) => {
            this.onEventSocket(e);
        });
    }
    // Asignamos el evento.
    onEventSocket(event) {
        console.debug('onEventSocket');
        console.debug(event);
        if (event.notify) {
            event.notify.created_at = event.created_at * 1000;
            this.addNotification(event.notify);
        }
    }
    removeAllNotification() {
        for (var i of this.intances) {
            i.onClose();
        }
    }
    addNotification(notify) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(EventNotifyComponent);
        const viewContainerRef = this.notificationStack.viewContainerRef;
        //viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory, 0);
        let instance = componentRef.instance;
        instance.event.componentViewRef = componentRef.hostView;
        instance.notify = notify;
        instance.close.subscribe((e) => {
            this.removeNotification(e.componentViewRef);
            var index = this.intances.indexOf(instance);
            this.intances.splice(index, 1);
        });
        this.intances.push(instance);
    }
    removeNotification(child) {
        const viewContainerRef = this.notificationStack.viewContainerRef;
        let i = viewContainerRef.indexOf(child);
        viewContainerRef.remove(i);
    }
}
EventNotifyWatcherComponent.ɵfac = function EventNotifyWatcherComponent_Factory(t) { return new (t || EventNotifyWatcherComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
EventNotifyWatcherComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EventNotifyWatcherComponent, selectors: [["event-notify-watcher"]], viewQuery: function EventNotifyWatcherComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(EventNotificationDirective, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.notificationStack = _t.first);
    } }, inputs: { token: "token", eventHost: "eventHost", account_id: "account_id" }, decls: 5, vars: 2, consts: [["aria-live", "polite", "aria-atomic", "true", 1, "toast-container"], ["type", "button", "data-dismiss", "toast", "aria-label", "Close", 1, "ml-2", "mb-1", "close", "btn-close-all", 3, "hidden", "click"], [1, "toast-stack"], ["event-notification-stack", ""]], template: function EventNotifyWatcherComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function EventNotifyWatcherComponent_Template_button_click_1_listener() { return ctx.removeAllNotification(); });
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵtemplate(4, EventNotifyWatcherComponent_ng_template_4_Template, 0, 0, "ng-template", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.intances.length == 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" Cerrar Todo (", ctx.intances.length, ") ");
    } }, directives: [EventNotificationDirective], styles: [".toast-container[_ngcontent-%COMP%]{min-height:200px;top:0;z-index:99999}.toast-container[_ngcontent-%COMP%], .toast-stack[_ngcontent-%COMP%]{position:fixed;bottom:0;right:0}.toast-stack[_ngcontent-%COMP%]{top:40px;padding:0 1px 0 0;overflow-y:auto}.btn-close-all[_ngcontent-%COMP%]{margin-right:12px;margin-top:4px;font-size:13px;background:#ff4545;color:#fff;padding:5px 13px;border-radius:10px;opacity:1;text-shadow:none;border:1px solid hsla(0,0%,100%,.9)}.btn-close-all[_ngcontent-%COMP%]:focus{outline:none}"] });
EventNotifyWatcherComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver }
];
EventNotifyWatcherComponent.propDecorators = {
    notificationStack: [{ type: ViewChild, args: [EventNotificationDirective, { static: true },] }],
    token: [{ type: Input }],
    eventHost: [{ type: Input }],
    account_id: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EventNotifyWatcherComponent, [{
        type: Component,
        args: [{
                selector: 'event-notify-watcher',
                template: "<div aria-live=\"polite\" aria-atomic=\"true\" class=\"toast-container\">\n    <button [hidden]=\"intances.length == 0\" type=\"button\" \n        class=\"ml-2 mb-1 close btn-close-all\" \n        data-dismiss=\"toast\" aria-label=\"Close\" \n        (click)=\"removeAllNotification()\">\n        Cerrar Todo ({{intances.length}})\n    </button>\n    <div class=\"toast-stack\">\n        <ng-template event-notification-stack></ng-template>\n    </div>\n</div>\n",
                styles: [".toast-container{min-height:200px;top:0;z-index:99999}.toast-container,.toast-stack{position:fixed;bottom:0;right:0}.toast-stack{top:40px;padding:0 1px 0 0;overflow-y:auto}.btn-close-all{margin-right:12px;margin-top:4px;font-size:13px;background:#ff4545;color:#fff;padding:5px 13px;border-radius:10px;opacity:1;text-shadow:none;border:1px solid hsla(0,0%,100%,.9)}.btn-close-all:focus{outline:none}"]
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }]; }, { token: [{
            type: Input
        }], eventHost: [{
            type: Input
        }], account_id: [{
            type: Input
        }], notificationStack: [{
            type: ViewChild,
            args: [EventNotificationDirective, { static: true }]
        }] }); })();

const routes = [];
class EventStreamLibRoutingModule {
}
EventStreamLibRoutingModule.ɵfac = function EventStreamLibRoutingModule_Factory(t) { return new (t || EventStreamLibRoutingModule)(); };
EventStreamLibRoutingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EventStreamLibRoutingModule });
EventStreamLibRoutingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[RouterModule.forChild(routes)], RouterModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EventStreamLibRoutingModule, { imports: function () { return [ɵngcc2.RouterModule]; }, exports: function () { return [RouterModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EventStreamLibRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [RouterModule.forChild(routes)],
                exports: [RouterModule]
            }]
    }], null, null); })();

class EventStreamLibModule {
}
EventStreamLibModule.ɵfac = function EventStreamLibModule_Factory(t) { return new (t || EventStreamLibModule)(); };
EventStreamLibModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EventStreamLibModule });
EventStreamLibModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            HttpClientModule,
            EventStreamLibRoutingModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EventStreamLibModule, { declarations: function () { return [EventNotificationDirective, EventNotifyComponent, EventNotifyWatcherComponent]; }, imports: function () { return [CommonModule,
        HttpClientModule, EventStreamLibRoutingModule]; }, exports: function () { return [EventNotifyWatcherComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EventStreamLibModule, [{
        type: NgModule,
        args: [{
                declarations: [EventNotificationDirective, EventNotifyComponent, EventNotifyWatcherComponent],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    EventStreamLibRoutingModule
                ],
                entryComponents: [EventNotifyComponent],
                exports: [EventNotifyWatcherComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of ng-alto-event-stream-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EventNotifyWatcherComponent, EventStreamLibModule, EventNotificationDirective as ɵa, EventNotifyComponent as ɵb, SysNotifyService as ɵc, EventStreamLibRoutingModule as ɵd };

//# sourceMappingURL=ng-alto-event-stream-lib.js.map